import { Input } from '@/components/editor/Input'
import { CallbackWrap } from '@/types/common'
import { Embed } from '@/types/embed'
import { LevelingEmbed } from '@/types/leveling'
import { faEdit } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Widget } from 'leveling/widget'
import React, { useMemo } from 'react'
import './planner-link.scss'

export function PlannerLink({
  embed,
  onEmbedChange
}: {
  embed: LevelingEmbed
  onEmbedChange?: (value: CallbackWrap<Embed>) => void
}) {
  const content = embed?.overview.plannerId || undefined
  const [isEditing, setIsEditing] = React.useState(false)

  const onEdit = (newValue: string | undefined) =>
    onEmbedChange?.((embed) => {
      if (embed.type !== 'leveling') return embed
      return { ...embed, overview: { ...embed.overview, plannerId: newValue } }
    })

  const plannerLink = useMemo(() => `https://maxroll.gg/poe/planner/${content}`, [content])

  return content || onEmbedChange ? (
    <Widget
      className="poe-planner-link-wrapper"
      title={
        <>
          Planner
          {onEmbedChange &&
            (isEditing ? (
              <div>
                <button onClick={() => setIsEditing(false)}>Close</button>
              </div>
            ) : (
              <div>
                <FontAwesomeIcon
                  icon={faEdit}
                  onClick={() => {
                    setIsEditing(!isEditing)
                  }}
                />
              </div>
            ))}
        </>
      }>
      <div className="poe-planner-links">
        {isEditing ? (
          <div className="poe-planner-link-edit">
            <Input
              placeholder="Planner ID"
              value={content ?? ''}
              onChange={
                onEmbedChange
                  ? (newValue) => {
                      onEdit(newValue)
                    }
                  : undefined
              }
            />
          </div>
        ) : (
          <div className="poe-planner-link">
            <span className="poe-planner-link-left">
              <span>Link:</span>
              <span
                className="poe-link-text"
                onClick={(event) => {
                  window.open(plannerLink, '_blank')
                }}>
                {plannerLink}
              </span>
            </span>
          </div>
        )}
      </div>
    </Widget>
  ) : null
}
